export default __webpack_public_path__ + "static/media/alert.36e27093.svg";